import React from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import ReactHtmlParser from 'html-react-parser';

function InfoMessage({ title, message }) {
    return (
        <div className="row">
            <div className="col-md-12 col-sm-12 col-xs-12">
                <Alert severity="info" className="text-left">
                    {title &&
                        <AlertTitle>{title}</AlertTitle>
                    }
                    {ReactHtmlParser(message)}						
                </Alert>
            </div>
        </div>
    )
}

export default InfoMessage;